import React from 'react';
import sprintf from 'sprintf';

class SMSocialMailLink extends React.Component {

  constructor(props) {
    super(props);
    this.clickMailLink = this.clickMailLink.bind(this);
  }

  clickMailLink() {
    // Google Analytics
    const gaLabel = this.props.gaLabel;
    if (typeof ga != 'function') {
      return;
    }
    ga('send', 'event', 'button', 'click', gaLabel);
  }

  render() {
    const subject = this.props.subject;
    const body = this.props.body;
    const mailUrl = sprintf("mailto:?subject=%s&body=%s", subject, body);

    return (
      <a href={mailUrl} onClick={this.clickMailLink} className="referral__social-link-mail">
        <i className="fa fa-envelope"></i>
      </a>
    );
  }
}
export default SMSocialMailLink;




// WEBPACK FOOTER //
// ./app/javascript/components/social/SMSocialMailLink.jsx